import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const ProfilePage = lazy(() => import('./profile-page').then((m) => ({ default: m.ProfilePage })));

export const profileRoutes: RouteObject[] = [{ path: 'profile', element: <ProfilePage />, handle: { crumb: 'My Profile' } }];
